import { RiskFactor } from '@/repositories/risk.repository';

export const sortRiskFactors = (a: RiskFactor, b: RiskFactor) => {
  if (a.impact > 0 && b.impact < 0) return 1;
  if (a.impact < 0 && b.impact > 0) return -1;
  return Math.abs(b.impact) - Math.abs(a.impact);
};
